import React from 'react';
import PropTypes from 'prop-types';

import './ProductSearchUGCResultsShowMore.scss';

const ProductSearchUGCResultsShowMore = ({ count, handleClickShowMore, disabled }) => {

	const displayShowMoreText = () => {

		if (count >= 10) return 'Show 10 More Results';
		return `Show ${count} More ${count === 1 ? 'Result' : 'Results'}`;

	};
	return (
		<button
			type="button"
			className="ProductSearchUGCResultsShowMore"
			onClick={handleClickShowMore}
			disabled={disabled}
		>
			<span>+ </span>
			<span className="ProductSearchUGCResultsShowMore__text">
				{displayShowMoreText()}
			</span>
		</button>
	);

};
ProductSearchUGCResultsShowMore.propTypes = {
	count: PropTypes.number.isRequired,
	handleClickShowMore: PropTypes.func.isRequired,
	disabled: PropTypes.bool.isRequired
};
export default ProductSearchUGCResultsShowMore;
